import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';
import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import typographyStyles from 'craft/resolvers/Typography/constants';
import { CommonNodeProperties } from 'craft/types';

interface Props {
  nodeIds: string[];
}

export const ListItemVariantSelector = ({ nodeIds }: Props) => {
  const {
    css,
    custom,
    actions: { setCustom },
  } = useMultiNodes(
    nodeIds,
    (node) => ({
      custom: Object.keys(node?.data.custom?.custom ?? {}).length
        ? node?.data.custom?.custom
        : { variant: 'P' },
      css: node?.data.custom?.css ?? {},
    }),
    CommonNodeProperties.Multiple,
  );

  const { textAlign, color, ...otherCss } = css;

  const changeVariant = (variant: VariantNode) => {
    const conditionVariant = variant.conditions.variant;
    const defaultCss = (typographyStyles as any)[conditionVariant] || typographyStyles.P;
    setCustom({
      custom: variant.conditions,
      css: { ...defaultCss, ...otherCss, textAlign },
    });
  };

  const variantId = custom.variant === 'P' ? 'base' : custom.variant;
  return (
    <Variants
      name={custom.variation || variantId}
      componentName="Typography"
      onSelectVariant={changeVariant}
      conditions={custom}
    />
  );
};
